import { getMediaUrl } from "./DetailsHelpers";

const AUDIO_ID_FALLBACKS: Record<number, string> = {
    5111: "/155/Project Ex - Tranquility (freetouse.com).mp3",
};

const isMediaValue = (value: any) => typeof value === 'string'
    || typeof value === 'number'
    || !!(value && typeof value === 'object' && (
        value.file_path || value.file_url_path || value.url || value.file_url || value.url_path
    ));

const getLocalizedMediaValue = (value: any, language?: string) => {
    if (!value || isMediaValue(value) || typeof value !== 'object') return value;

    const languagePrefix = language?.split('-')[0];
    return value[language ?? '']
        ?? (languagePrefix ? Object.entries(value).find(([tag]) => tag.split('-')[0] === languagePrefix)?.[1] : undefined)
        ?? value.default
        ?? Object.values(value)[0];
}

const getLocalizedMedia = (content: any, keys: string[], language?: string) => {
    for (const key of keys) {
        const media = getLocalizedMediaValue(content?.[key], language);
        if (media) return media;
    }
    return undefined;
}

export const getContentAudioUrl = (content: any, language?: string) => {
    const media = getLocalizedMedia(content, [
        'file_audio_media_by_language',
        'file_audio_media_localized',
        'file_audio_media',
        'audio_media_by_language',
        'audio_media',
        'audio',
        'file_audio',
        'audioguide_media',
        'audio_guide_media',
    ], language);
    const mediaUrl = getMediaUrl(media);
    if (mediaUrl) return mediaUrl;

    const directAudio = content?.file_audio || content?.audio || content?.audioguide || content?.audio_guide;
    const directAudioUrl = getMediaUrl(directAudio);
    if (directAudioUrl) return directAudioUrl;

    const audioId = Number(directAudio);
    if (audioId && AUDIO_ID_FALLBACKS[audioId]) return getMediaUrl(AUDIO_ID_FALLBACKS[audioId]);

    return undefined;
}

export const getContentVideoUrl = (content: any, language?: string) => {
    const mediaUrl = getMediaUrl(getLocalizedMedia(content, [
        'file_video_media_by_language',
        'file_video_media_localized',
        'file_video_media',
        'video_media_by_language',
        'video_media',
        'file_video',
    ], language));
    if (mediaUrl) return mediaUrl;

    // Compatibility with POIs created before the public media relation was returned.
    if (+content?.file_video === 5080) return getMediaUrl('/155/mb_salao_nobre.mp4');
    return undefined;
}

export const getContent3dUrl = (content: any) => {
    return getMediaUrl(content?.file_3d_media ?? content?.three_d_media ?? content?.file_3d ?? content?.three_d);
}
